import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { SaveCallScriptFormResult } from "../types/SaveCallScriptFormResult";
import { SaveChangeOrderFormParams } from "../types/SaveChangeOrderFormParams";

export const useSaveChangeOrderScriptForm = (
	params: SaveChangeOrderFormParams,
	onSuccess: (result: SaveCallScriptFormResult) => void,
	onError: (error: string) => void) => {

	let method = '';
	let requestParams: any;
	method = 'save-changeOrderForm';
	requestParams = {
		RetailOrderID: params.formObject.RetailOrderID,
		RetailOrderNo: params.formObject.RetailOrderNo,
		AfterFinalPaymentCheckBox: params.formObject.AfterFinalPaymentCheckBox,
		AfterStepsCompletedCheckbox: params.formObject.AfterStepsCompletedCheckbox,
		Delivering10StarCheckBox: params.formObject.Delivering10StarCheckBox,
		Delivering10StarClosingCheckBox: params.formObject.Delivering10StarClosingCheckBox,
		IntroduceYourselfCheckBox: params.formObject.IntroduceYourselfCheckBox,
		LowesSurveyPerfectCheckBox: params.formObject.LowesSurveyPerfectCheckBox,
		LowesSurveyPerfectClosingCheckBox: params.formObject.LowesSurveyPerfectClosingCheckBox,
		MayISpeakCheckBox: params.formObject.MayISpeakCheckBox,
		ThankCustomerForPurchaseCheckBox: params.formObject.ThankCustomerForPurchaseCheckBox,
		ThankTheCustomerCheckBox: params.formObject.ThankTheCustomerCheckBox,
		ToApproveCheckBox: params.formObject.ToApproveCheckBox,
		ToPayTheNewBalanceCheckbox: params.formObject.ToPayTheNewBalanceCheckbox,
		YouWillRecieveCheckBox: params.formObject.YouWillRecieveCheckBox,
		YouWillRecieveNONImeCheckbox: params.formObject.YouWillRecieveNONImeCheckbox,
		YourProjectHoldCheckBox: params.formObject.YourProjectHoldCheckBox,
		ConfirmSelectionsCheckbox: params.formObject.ConfirmSelectionsCheckbox,
		ColorFinishCheckbox: params.formObject.ColorFinishCheckbox,
		ColorFinishText: params.formObject.ColorFinishText,
		EdgeCheckbox: params.formObject.EdgeCheckbox,
		EdgeText: params.formObject.EdgeText,
		BacksplashCheckbox: params.formObject.BacksplashCheckbox,
		CustomerSuppliedCheckbox: params.formObject.CustomerSuppliedCheckbox,
		SlabCheckbox: params.formObject.SlabCheckbox,
		Thickness3cmCheckbox: params.formObject.Thickness3cmCheckbox,
		Thickness2cmCheckbox: params.formObject.Thickness2cmCheckbox,
		HeightStandard4Checkbox: params.formObject.HeightStandard4Checkbox,
		HeightFullCheckbox: params.formObject.HeightFullCheckbox,
		FullHeightText: params.formObject.FullHeightText,
		OtherCheckbox: params.formObject.OtherCheckbox,
		OtherText: params.formObject.OtherText,
		SQFTChangesCheckbox: params.formObject.SQFTChangesCheckbox,
		OversizeSlabText: params.formObject.OversizeSlabText,
		OversizeSlabCheckbox: params.formObject.OversizeSlabCheckbox,
		ExtendedOverhangsCheckbox: params.formObject.ExtendedOverhangsCheckbox,
		ExtendedOverhangsText: params.formObject.ExtendedOverhangsText,
		SupportCustomerSuppliedCheckbox: params.formObject.SupportCustomerSuppliedCheckbox,
		SupportInstallerProvidedCheckbox: params.formObject.SupportInstallerProvidedCheckbox,
		PlumbingDisconnectCheckbox: params.formObject.PlumbingDisconnectCheckbox,
		PlumbingDisconnectInstallerCheckbox: params.formObject.PlumbingDisconnectInstallerCheckbox,
		PlumbingDisconnectCustomerCheckbox: params.formObject.PlumbingDisconnectCustomerCheckbox,
		Plumbing1120679Checkbox: params.formObject.Plumbing1120679Checkbox,
		Plumbing1120669Checkbox : params.formObject.Plumbing1120669Checkbox,
		ChipMinimizerCheckbox: params.formObject.ChipMinimizerCheckbox,
		SafetyCornersCheckbox: params.formObject.SafetyCornersCheckbox,
		PlumbingReconnectCheckbox: params.formObject.PlumbingReconnectCheckbox,
		PlumbingReconnectInstallerCheckbox: params.formObject.PlumbingReconnectInstallerCheckbox,
		PlumbingReconnectCustomerCheckbox: params.formObject.PlumbingReconnectCustomerCheckbox,
		Granite1120680Checkbox: params.formObject.Granite1120680Checkbox,
		Granite1120686Checkbox: params.formObject.Granite1120686Checkbox,
		Granite1120685Checkbox: params.formObject.Granite1120685Checkbox,
		Granite1120684Checkbox: params.formObject.Granite1120684Checkbox,
		Quartz1120670Checkbox: params.formObject.Quartz1120670Checkbox,
		Quartz1120676Checkbox: params.formObject.Quartz1120676Checkbox,
		Quartz1120675Checkbox: params.formObject.Quartz1120675Checkbox,
		Quartz1120674Checkbox: params.formObject.Quartz1120674Checkbox,
		GraniteGoldProtectionPlanCheckbox: params.formObject.GraniteGoldProtectionPlanCheckbox,
		Gold5YearCheckbox: params.formObject.Gold5YearCheckbox,
		Gold10YearCheckbox: params.formObject.Gold10YearCheckbox,
		AfterISubmitCheckboxIME: params.formObject.AfterISubmitCheckboxIME,
		SendSigningLinkCheckbox: params.formObject.SendSigningLinkCheckbox,
		AfterISubmitCheckboxNonIME: params.formObject.AfterISubmitCheckboxNonIME,
		NoteText:params.formObject.NoteText
	};

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/" + method, requestParams) as SaveCallScriptFormResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)	
				onSuccess(result);
			else
				onError(`Error when saving the pdf file"}: ` +
					result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}